import { Base } from "./base";
import { getAccessToken } from "../utils/browserStorage";

export class VendorType extends Base {
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */
  list(query) {
    let queryParam = new URLSearchParams(query).toString();
    const url = this._getFullURL("/cmms/vendor-type?" + queryParam);
    return this._secureFetch(url);
  }
  /**
   * @description List Location API function
   * @returns {Promise<Response>}
   */

  create(payload) {
    const url = this._getFullURL("/cmms/vendor-type");

    return fetch(url, this._generateRequestBody({ payload, method: "POST" }));
  }
  update(id, payload) {
    const url = this._getFullURL("/cmms/vendor-type/" + id);
    return fetch(url, this._generateRequestBody({ payload, method: "PUT" }));
    
  }

  delete = (id) => {
    const url = this._getFullURL(`/cmms/vendor-type/${id}`);
    return fetch(
      url,
      this._generateRequestBody({
        authentication: true,
        payload: null,
        method: "DELETE",
      })
    );
  };
}
